import { produce, Draft } from 'immer'

import {
  IAction,
  TActionTypes
} from '@Root/types'

import {
  IStatisticsState,
  TStatisticsActionTypes,
  StatisticsActionTypes,
  IGetCreditUsageSuccessResponseBody,
  IGetProjectCreationSuccessResponseBody,
} from './types'

export const initialState: IStatisticsState = {
  loading: false,
  creditUsageData: { analysis: [], nonAnalysis: [] },
  projectCreationData: []
}

type TAction = TActionTypes | TStatisticsActionTypes

export const statisticsReducer = (
  state: IStatisticsState = initialState,
  action: TAction,
): IStatisticsState => {
  return produce(state, draft => {
    switch (action.type) {
      case StatisticsActionTypes.GET_CREDIT_USAGE:
        getCreditUsage(draft)
        break

      case StatisticsActionTypes.GET_CREDIT_USAGE_SUCCESS:
        getCreditUsageSuccess(draft, action)
        break

      case StatisticsActionTypes.GET_CREDIT_USAGE_FAILURE:
        getCreditUsageFailure(draft)
        break

      case StatisticsActionTypes.GET_PROJECT_CREATION:
        getProjectCreation(draft)
        break

      case StatisticsActionTypes.GET_PROJECT_CREATION_SUCCESS:
        getProjectCreationSuccess(draft, action)
        break

      case StatisticsActionTypes.GET_PROJECT_CREATION_FAILURE:
        getProjectCreationFailure(draft)
        break

      default:
        break
    }
  })
}

const getCreditUsage = (draft: Draft<IStatisticsState>) => {
  draft.loading = true
}

function isIGetCreditUsageSuccessAction(arg: any): arg is IAction<IGetCreditUsageSuccessResponseBody> {
  return arg.type === StatisticsActionTypes.GET_CREDIT_USAGE_SUCCESS
}

const getCreditUsageSuccess = (draft: Draft<IStatisticsState>, action: TAction) => {
  if (!isIGetCreditUsageSuccessAction(action)) { return }

  draft.creditUsageData = action.payload.statistics
  draft.loading = false
}

const getCreditUsageFailure = (draft: Draft<IStatisticsState>) => {
  draft.loading = false
}

const getProjectCreation = (draft: Draft<IStatisticsState>) => {
  draft.loading = true
}

function isIGetProjectCreationSuccessAction(arg: any): arg is IAction<IGetProjectCreationSuccessResponseBody> {
  return arg.type === StatisticsActionTypes.GET_PROJECT_CREATION_SUCCESS
}

const getProjectCreationSuccess = (draft: Draft<IStatisticsState>, action: TAction) => {
  if (!isIGetProjectCreationSuccessAction(action)) { return }

  draft.projectCreationData = action.payload.statistics
  draft.loading = false
}

const getProjectCreationFailure = (draft: Draft<IStatisticsState>) => {
  draft.loading = false
}
